"use client"
import AppLayout from "../../templates/AppLayout";
import RefundPolicyOrganism from "../../organisms/RefundPolicy/index";

const ReturnRefundPolicyPage = () => {
  return (
    <AppLayout>
      <main className="bg-background text-on-surface font-body">
        
        <RefundPolicyOrganism />
      </main>
    </AppLayout>
  );
};

export default ReturnRefundPolicyPage;